import { render, staticRenderFns } from "./SAccProjectSheet.vue?vue&type=template&id=2c14e021&scoped=true"
import script from "./SAccProjectSheet.vue?vue&type=script&lang=ts"
export * from "./SAccProjectSheet.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c14e021",
  null
  
)

export default component.exports